import { buildExchangeParam } from 'src/lib/item'
import { postExchangeShop } from 'src/services/post/postExchangeShop'

import ConfirmModal from 'src/pages/main/shop/components/ShopExchangeTab/ConfirmModal'

const openExchangeConfirmModal = ({
  selectedItem,
  selectedExchange,
  totalPoints,
  handleChangeTab,
  closeModal,
  setModalContent,
  setButtons,
  setTitle,
  refetchExchangeItem,
  refetchMaterialItem
}) => {
  const payload = {
    shop_exchange_setting_id: selectedItem.id,
    user_character_cloths: buildExchangeParam(selectedExchange)
  }

  setTitle('確認')
  setButtons([
    { label: 'キャンセル', onClick: closeModal, type: 'close' },
    {
      label: 'OK',
      onClick: async () => {
        try {
          await postExchangeShop(payload)
          await Promise.all([refetchExchangeItem(), refetchMaterialItem()])
          closeModal()
          handleChangeTab()
        } catch (error) {
          console.error(error)
        }
      }
    }
  ])
  setModalContent(
    <ConfirmModal
      item={selectedItem}
      currentPoint={totalPoints}
      pointSpend={selectedItem.material_points}
    />
  )
}

export default openExchangeConfirmModal
